import React from "react";
import Banner from "../../components/Banner";
import ChoosingUs from "../../components/ChoosingUs";
import ServicesHome from "../../components/ServicesHome";
import CaseStudy from "../../components/CaseStudy";
import Real from "../../components/Real";
import Hero from "../../components/Hero/Hero.jsx";
import Footer from "../../components/Footer";
import AboutUsHome from "../../components/AboutUsHome";
import Testimonial from "../../components/Testimonial";
import Cards from "../../components/Cards/Cards";
const Home = () => {
  return (
    <>
      <section>
        <Hero />
      </section>

      <section>
        <AboutUsHome />
      </section>

      <section>
        <Real />
      </section>
      <section>
        <Cards />
      </section>
      {/* Testimonial Section  */}
      <section>
        <Testimonial />
      </section>

      {/* Footer Section  */}
      <section>
        <Footer />
      </section>
    </>
  );
};

export default Home;
